export default "__VITE_ASSET__bef9d434__"